
(() => {
  class SiteHeader extends HTMLElement {
    connectedCallback() {
      this.mode = this.dataset.sticky || 'scroll-up';
      this.lastY = window.scrollY;
      this.threshold = 80;

      this.setHeightVar();
      this.resizeObserver = new ResizeObserver(() => this.setHeightVar());
      this.resizeObserver.observe(this);

      if (this.mode !== 'none') this.classList.add('site-header--sticky');

      this.onScroll = window.ThemeUtils.throttleRaf(() => this.handleScroll());
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.handleScroll();
    }

    setHeightVar() {
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
      this.setChromeVar();
    }

    setChromeVar() {
      const bottom = Math.max(0, Math.round(this.getBoundingClientRect().bottom));
      document.documentElement.style.setProperty('--sa-top-chrome', `${bottom}px`);
    }

    handleScroll() {
      const y = window.scrollY;
      this.classList.toggle('is-scrolled', y > 4);
      this.setChromeVar();   

      if (this.mode === 'scroll-up') {
        const goingDown = y > this.lastY;

        const menuOpen = !!this.querySelector('details[open]');
        const locked = document.body.classList.contains('scroll-locked');
        this.classList.toggle('is-hidden', goingDown && y > this.threshold && !menuOpen && !locked);
      }
      this.lastY = y;
    }

    disconnectedCallback() {
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      this.resizeObserver?.disconnect();
    }
  }

  class DetailsMenu extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      if (!this.details) return;

      this.details.addEventListener('toggle', () => {
        if (!this.details.open) return;

        document.querySelectorAll('details-menu details[open]').forEach((d) => {
          if (d !== this.details) d.open = false;
        });
      });

      this.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        this.details.open = false;
        this.summary?.focus();
      });

      this.onDocClick = (e) => {
        if (this.details.open && !this.contains(e.target)) this.details.open = false;
      };
      document.addEventListener('click', this.onDocClick);

      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        this.addEventListener('mouseenter', () => { this.details.open = true; });
        this.addEventListener('mouseleave', () => { this.details.open = false; });
        this.addEventListener('focusout', (e) => {
          if (!this.contains(e.relatedTarget)) this.details.open = false;
        });
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
    }
  }

  if (!customElements.get('site-header')) customElements.define('site-header', SiteHeader);
  if (!customElements.get('details-menu')) customElements.define('details-menu', DetailsMenu);
})();
